export default __webpack_public_path__ + "media/Alcohol-Bottle-Can-Beer.89536f78.png";